import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
      <Sidebar />
      <div style={{ flex: 1, padding: '20px', background: '#f9f9f9', minHeight: '100vh' }}>
        {children}
      </div>
    </div>
  );
};

export default Layout;
